export default {
  // 标题
  title: "扫码绑定",

  // 加载提示
  loading: "拼命加载中",

  // 平台名称
  wechat: "微信",
};
